import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GenericModal } from '@org/ui';
import { trpc } from '@org/clients/school';
import { unwrapTrpcData } from '@org/ui';
import { ClassMultiStepForm } from '../../app/components/class/class-multi-step-form';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/classes/$classId')({
  component: ClassDetailRoute,
});

function ClassDetailRoute() {
  const { classId } = Route.useParams();
  const navigate = useNavigate({ from: '/classes/$classId' });
  const { t } = useTranslation('admin');
  const utils = trpc.useUtils();
  const { data, isLoading } = trpc.classes.get.useQuery({ id: classId });
  const classItem = unwrapTrpcData(data);

  const handleClose = () => {
    navigate({ to: '/classes', replace: true });
  };

  const handleSubmit = async () => {
    await utils.classes.list.invalidate();
    handleClose();
  };

  return (
    <GenericModal
      show
      onClose={handleClose}
      title={t('classes.form.editTitle')}
      size="xl"
      centered
      confirmOnClose
      confirmCloseMessage={t('classes.form.confirmClose')}
      body={
        isLoading ? (
          <div className="flex h-40 items-center justify-center text-muted-foreground">
            {t('classes.form.loadingClass')}
          </div>
        ) : classItem ? (
          <ClassMultiStepForm
            defaultValues={classItem}
            onSubmit={handleSubmit}
            onClose={handleClose}
            isEditing
          />
        ) : (
          <div className="flex h-40 items-center justify-center text-muted-foreground">
            {t('classes.form.notFound')}
          </div>
        )
      }
      footer={<></>}
    />
  );
}


